
//this code is for size chart section
if(!customElements.get('size-chart')) {
class SizeChart extends HTMLElement {
    constructor() {
        super();

        this.nav = this.querySelector('#chart-value-nav');
        this.main = this.querySelector('#chart-value-main');

        // If both elements are found, initialize the size chart
        if (this.nav && this.main) {
            this.init();
        }
    }

    init() {
        // Initialize the Flickity carousel for the 'chart-value-main' element
        let mainCarousel = new Flickity(this.main, {
            pageDots: false,
            prevNextButtons: true,
            watchCSS: true
        });

        // Initialize the Flickity carousel for the 'chart-value-nav' element
        let navCarousel =  new Flickity(this.nav, {
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            watchCSS: true
        });

        // link main carousel to nav carousel
        mainCarousel.on('change', function(index) {
            navCarousel.select(index);
        });
        // link nav carousel to main carousel
        navCarousel.on('change', function(index) {
            mainCarousel.select(index);
        });
    }
}

customElements.define('size-chart', SizeChart);
}



